// 用于兄弟传值
// 快递员，负责兄弟组件之间传递数据
import Vue from 'vue';
// 导出一个Vue对象
// 注意：这是一个新的对象，与main.js里边的没有关系
export default new Vue();